export const clearMockData = (key: string) => () =>
  localStorage.removeItem(key);

export const clearAllMockData = () => localStorage.clear();
